import { render } from "./B2bPageAuditoriaDocumentos.vue?vue&type=template&id=25686d79&scoped=true&lang=pug"
import script from "./B2bPageAuditoriaDocumentos.vue?vue&type=script&lang=js"
export * from "./B2bPageAuditoriaDocumentos.vue?vue&type=script&lang=js"

import "./B2bPageAuditoriaDocumentos.vue?vue&type=style&index=0&id=25686d79&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25686d79"]])

export default __exports__